export const AXIOS_CANCELLED_REQUEST_ERROR_CODE = 'ERR_CANCELED';
